<template>
  <a-modal
    :title="title"
    :width="860"
    :visible="visible"
    :imageUrl="imageUrl"
    ok-text="确定"
    cancel-text="取消"
    @ok="
      () => {
        $emit('ok');
        radioGroup = null
        radioGroup1 = null
      }
    "
    @cancel="
      () => {
        $emit('cancel');
        radioGroup = null
        radioGroup1 = null
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="名称">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入名称' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="图标">
          <a-upload
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="uploadPath"
            @change="handleChange"
            :headers="headers"
          >
            <img v-if="imageUrl2" :src="imageUrl2" style="width:400px" alt="icon" />
            <div v-else>
              <a-icon :type="iconUpload ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="算法模型">
          <!-- 旧版本 -->
          <a-select v-decorator="['networkModelId',{ rules: [{ required: true, message: '请选择算法模型' }] }]">
            <a-select-option v-for="d in networkModelList" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
          <!-- 旧版本 -->

          <!-- <div class="box">

         
          <div style="display:flex;align-items: center;margin-bottom:20px">
            <div style="width:70px;text-align: left;height:68px">
               分类：
            </div>
           <div>
             <a-radio-group v-model="radioGroup" ref="radioGroup" @change="changeRadioGroup">
              <a-radio :value="1"> 分类 </a-radio>
              <a-radio :value="2"> 分割 </a-radio>
              <a-radio :value="3"> 缺陷 </a-radio>
              <a-radio :value="4"> 异常 </a-radio>
              <a-radio :value="5"> ocr </a-radio>
            </a-radio-group>
           </div>
             <a-button @click="clearRadioGroup"> 清除 </a-button>
          </div>
          <a-divider />
          <div style="display:flex;align-items: center;margin-bottom:20px">
            <div style="width:110px;height:92px">
              行业：
            </div>
            <div>
              <a-radio-group v-model="radioGroup1" ref="radioGroup1" @change="changeRadioGroup1">
              <a-radio :value="1"> 通用 </a-radio>
              <a-radio :value="2"> 包装 </a-radio>
              <a-radio :value="3"> 粮食 </a-radio>
              <a-radio :value="4"> 羽毛 </a-radio>
              <a-radio :value="5"> 锂电 </a-radio>
              <a-radio :value="6"> 纺织 </a-radio>
              <a-radio :value="7"> 电容 </a-radio>
              <a-radio :value="100"> 其他 </a-radio>
            </a-radio-group>
            </div>
            <a-button @click="clearRadioGroup1"> 清除 </a-button>
          </div>
          <a-divider />
          <div>
            <a-select v-decorator="['networkModelId',{ rules: [{ required: true, message: '请选择算法模型' }] }]">
            <a-select-option v-for="d in networkModelList" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
          </div>
          
         </div> -->
        </a-form-item>
        <a-form-item label="备注">
          <a-input v-decorator="['memo']" type="textarea" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from "lodash.pick";
import { requestUrl } from "@/utils/request_url";
const fields = ["name", "memo", "networkModelId"];
export default {
  name: "ProjectForm",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "新增",
    },
    visible: {
      type: Boolean,
      required: true,
    },
    imageUrl: {
      type: Object,
      default: () => null,
    },
    networkModelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };
    return {
      form: this.$form.createForm(this),
      imageUrl2: "",
      iconUpload: false,
      headers: {},
      value: null,
      value1: null,
      radioGroup:null,
      radioGroup1:null
    };
  },
  created() {
    fields.forEach((v) => this.form.getFieldDecorator(v));
    this.$watch("imageUrl", () => {
      this.imageUrl2 = this.imageUrl.url;
    });
    this.$watch("model", () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields));
    });
  },
  // watch: {
  //   imageUrl: function (val) {
  //     debugger
  //   },
  // },
  computed: {
    uploadPath() {
      return requestUrl + "/train/rest/file/upload_project_icon";
    },
  },
  mounted() {},
  methods: {
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.iconUpload = true;
        return;
      }
      if (info.file.status === "done") {
        if (info.file.response.code === 10001) {
          this.imageUrl2 = requestUrl + info.file.response.data;
          this.iconUpload = false;
        }
      }
    },
    changeRadioGroup(e) {
      console.log(e.target.value);
      this.$emit('changeRadio',{property:this.radioGroup,industry:this.radioGroup1})
    },
    changeRadioGroup1(e) {
      console.log(e);
       this.$emit('changeRadio',{property:this.radioGroup,industry:this.radioGroup1})
    },
    clearRadioGroup() {
      this.radioGroup = null
      // this.radioGroup1 = null
      this.$emit('changeRadio',{property:this.radioGroup,industry:this.radioGroup1})
    },
    clearRadioGroup1() {
      this.radioGroup1 = null
      // this.radioGroup1 = null
      this.$emit('changeRadio',{property:this.radioGroup,industry:this.radioGroup1})
    }
  },
};
</script>
<style lang="scss" scoped>
.box{
  border: 1px dashed #ccc;
  padding: 10px;
  justify-content: space-around;
  justify-content: flex-end;
}
</style>
